import moment from 'moment';
import jstz from 'jstz';
// service to convert the input date to date in another time zone
export default function TimezoneService(usersService, appSettings) {
  'ngInject';

  const getUserDateFormat = () => appSettings.GetDateFormat();
  this.getUserTimezoneOffset = function(date) {
    let usertimezone;
    try {
      usertimezone = usersService.currentUser().claims.data.timezone;
    } catch (ex) {
      //do nothing
    }
    if (usertimezone) {
      return moment(date.toISOString())
        .tz(usertimezone)
        .utcOffset();
    } else {
      let zone = jstz.determine();
      return moment(date.toISOString())
        .tz(zone.name())
        .utcOffset();
    }
  };

  this.convertToSameTimeInUserTimeZone = function(date) {
    return moment(date.getTime() + date.getTimezoneOffset() * 60000 + this.getUserTimezoneOffset(date) * 60000);
  };

  this.convertToUserTimezone = function(date, dateformat) {
    let returnValue;
    let usertimezone;
    if (!date) {
      return '';
    }

    if (!dateformat) {
      dateformat = `${getUserDateFormat()} hh:mm A z`;
    }

    try {
      usertimezone = usersService.currentUser().claims.data.timezone;
    } catch (ex) {
      //do nothing
    }
    if (usertimezone) {
      returnValue = moment(date)
        .tz(usertimezone)
        .format(dateformat);
    } else {
      let zone = jstz.determine();
      returnValue = moment(date)
        .tz(zone.name())
        .format(dateformat);
    }

    return returnValue ? returnValue : '';
  };

  this.tagToUserTimezone = function(date) {
    let returnValue;
    let dateformat = 'MM/DD/YYYY hh:mm:ss A z';
    let usertimezone;
    if (!date) {
      return '';
    }
    try {
      usertimezone = usersService.currentUser().claims.data.timezone;
    } catch (ex) {
      //do nothing
    }
    if (usertimezone) {
      returnValue = moment(date)
        .tz(usertimezone)
        .format(dateformat);
    } else {
      let zone = jstz.determine();
      returnValue = moment(date)
        .tz(zone.name())
        .format(dateformat);
    }
    return returnValue ? returnValue : '';
  };
}
